import {css} from 'lit'; export default css`.green-icon{--goto-icon-color:var(--goto-green-300)}.yellow-icon{--goto-icon-color:var(--goto-warning-01)}.red-icon{--goto-icon-color:var(--goto-danger-01)}`;
    